import React from 'react';
import PropTypes from 'prop-types';
import Constants from "../utils/Constants";

import {
	makeStyles,
	Typography
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	activityType: {
		paddingBottom: 10,
		fontSize: "0.9rem",
		textTransform: "uppercase"
	},

	dot: {
		width: 10,
		height: 10,
		borderRadius: 50
	},

	"@keyframes opacityPulse": {
		"0%": {opacity: 0.3},
		"50%": {opacity: 1},
		"100%": {opacity: 0.3}
	},

	alertDot: {
		backgroundColor: "#E81717",
	},

	pulsatingDot: {
		opacity: 1,
		animationName: "$opacityPulse",
		animationDuration: "2s",
		animationTimingFunction: "ease-out",
		animationIterationCount: "infinite"
	},

	otherDot: {
		backgroundColor: theme.palette.primary.mediumGrey
	}
}));

function ActivityCategory(props) {
	let classes = styles(),
		{category, plural, useDot, pulsateAlerts, colorOverride} = props,
		activityType = (category === Constants.ACTIVITY.CATEGORIES.DISCUSSIONS.ID) ?
			Constants.ACTIVITY.CATEGORIES.DISCUSSIONS.NAME : Constants.ACTIVITY.CATEGORIES.ALERTS.NAME,
		activityTypeColor = category === Constants.ACTIVITY.CATEGORIES.DISCUSSIONS.ID ? 'textSecondary' : 'error',
		dotClassName = category === Constants.ACTIVITY.CATEGORIES.ALERTS.ID ?
			pulsateAlerts ? `${classes.alertDot} ${classes.pulsatingDot}` : classes.alertDot : classes.otherDot;

	return (
		useDot ?
			<div
				className={`${classes.dot} ${dotClassName}`}
				style={colorOverride ? {backgroundColor: colorOverride} : null}></div>
			:
			<Typography
				color={colorOverride ? colorOverride : activityTypeColor}
				className={classes.activityType}>{`${activityType}${plural ? "s" : ""}`}</Typography>

	);
}

ActivityCategory.defaultProps = {
	plural: false,
	useDot: false,
	pulsateAlerts: true,
	colorOverride: null
};

ActivityCategory.propTypes = {
	category: PropTypes.number,
	plural: PropTypes.bool,
	useDot: PropTypes.bool,
	pulsateAlerts: PropTypes.bool,
	colorOverride: PropTypes.string
};

export default ActivityCategory;
